module.exports = __webpack_public_path__ + "img/no-image-1.9e2eccd2.png";